import OptionField from '@fd/frontend/components/ProxyPoolCreatePage/OptionFieldCard';
import { Input } from '@fd/frontend/components/ui/Input';
import useProxyPoolCreationForm from '@fd/frontend/store/proxyPoolCreationFormStore';

export default function NameCard() {
  const { name, setName } = useProxyPoolCreationForm();

  return (
    <OptionField.Card>
      <OptionField.Body>
        <OptionField.Title>Name</OptionField.Title>
        <OptionField.Description>
          To help you find it amoung other pools in the dashboard.
        </OptionField.Description>
      </OptionField.Body>
      <Input
        minLength={1}
        maxLength={40}
        value={name}
        placeholder="Default proxy pool"
        onChange={(e) => {
          setName(e.target.value);
        }}
      />
    </OptionField.Card>
  );
}
